import * as PropTypes from 'prop-types';
import * as React from 'react';

import { getRandomId } from '../../utils/banners';
import { TgbBannerContainer } from '../adfox/templates/tgb/banner';

import * as styles from './index.css';

export interface IAsideBannersStoreProps {
  height: number;
}

/**
 * Нумерация начинается с 4-х потому что к моменту рендера этих баннеров,
 * на странице уже есть заняты первые 3 индекса для ТГБ баннера
 */
const pr1Randoms: {[key: number]: string} = {
  4: getRandomId(),
  5: getRandomId(),
  6: getRandomId(),
};

const BANNER_HEIGHT = 200;
const MIN_BANNERS_COUNT = 1;
const MAX_BANNERS_COUNT = 3;
/**
 * 4 это число сформированное из расчета что до вызова подгрузки этого баннера уже есть 3 ТГБ баннера
 */
const TGB_BANNERS_START_COUNT = 4;

let mounted = false;

export class AsideBanners extends React.Component<IAsideBannersStoreProps, {}> {
  public static contextTypes = {
    makeRequest: PropTypes.func,
  };

  public componentDidMount() {
    mounted = true;
  }

  public shouldComponentUpdate(nextProps: IAsideBannersStoreProps) {
    return mounted && getBannersCount(nextProps.height) !== getBannersCount(this.props.height);
  }

  public render() {
    const { height } = this.props;
    const bannersCount = mounted ? getBannersCount(height) : 0;

    if (!bannersCount) {
      return null;
    }

    return (
      <div className={styles['container']}>
        {[...Array(bannersCount)].map((item, index) => {
          return (
            <TgbBannerContainer
              key={`tgb${index + TGB_BANNERS_START_COUNT}`}
              randomId={pr1Randoms[index + 4]}
              positionInfo={`offer_card_tgb-${index + TGB_BANNERS_START_COUNT}`}
            />
          );
        })}
      </div>
    );
  }
}

function getBannersCount(height: number) {
  if (!height) {
    return 0;
  }

  const viewportHeight = window.innerHeight;
  const bannersCount = Math.floor((viewportHeight - height) / BANNER_HEIGHT);

  return Math.min(MAX_BANNERS_COUNT, Math.max(MIN_BANNERS_COUNT, bannersCount));
}
